import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';

import { CARTO_URL } from "../../Utils/Global";

/**
* Class MapModal
* MapModal view component
**/
class MapModal extends Component {

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {

    //var data = require('../../../public/configLayers.json'); // forward slashes will depend on the file location

    // try {
    //     let response = await fetch('http://canna/gpmg/configLayers.json');
    //     let responseJson = await response.json();
    //     data=responseJson
    //    } catch(error) {
    //     console.error(error);
    //   }
    // var Config = require('configLayers.json');
    // fetchData('http://canna/gpmg/configLayers.json');
    // data=Config;


    //console.log(data);
    //console.log(data.entities);

    var url=CARTO_URL;
    switch (this.props.queryLayers) {
      case "AlerteCreate":
        url = url.replace('[idcarte]','4');
        break;
      case "DocumentCreate":
        url = url.replace('[idcarte]','6');
        break;
      case "ElementContratCreate":
        url = url.replace('[idcarte]','8');
        break;
      case "ObjectifCreate":
        url = url.replace('[idcarte]','9');
        break;
      default:
        url = url.replace('[idcarte]','10');
        break;
    }
    

    //var entities=data.entities;

    // var queryLayers=this.props.queryLayers;
    // var allowDraw=this.props.allowDraw;
    // var selectionMultiple=this.props.selectionMultiple;
    // var typeGeometry=this.props.typeGeometry;

    // for(var i = 0; i < entities.length; i++) {
    //     var obj = entities[i];
    //     if (obj.name.toLowerCase()==this.props.queryLayers.toLowerCase())
    //     {
    //       console.log('trouve');
    //       queryLayers=obj.queryLayers;
    //       allowDraw=obj.allowDraw;
    //       selectionMultiple=obj.selectionMultiple;
    //       typeGeometry=obj.typeGeometry;
    //         //this.props.queryLayers=obj.queryLayers;
    //         //this.props.allowDraw=obj.allowDraw;
    //         //this.props.selectionMultiple=obj.selectionMultiple;
    //         //this.props.typeGeometry=obj.typeGeometry;
    //     }
    // }

    return(
      <Modal dialogClassName="modal-geom" show={this.props.mapFrame} onHide={this.props.onHide}>
        <Modal.Header closeButton>
          <Modal.Title>Sélection de géométrie</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <iframe width="100%" height="100%"
            src={url} />
        </Modal.Body>
      </Modal>
    );
	}

}
export default MapModal;



// WEBPACK FOOTER //
// ./src/views/Helper/MapModal.js